<div class="top-header">
  <lib-header
    [title]="''"
    #headerRef
    [user]="userName"
    (darkModeToggle)="onDarkModeToggle()"
    [isDarkMode]="isDarkMode"
    [logoUrl]="logoUrl"
    [showToggle]="false"
    [showLogout]="false"
    (profileClick)="showMenu(headerRef)"
    (logout)="onLogout()"
    [showSearch]="showSearch"
    [showNotifications]="showNotifications"
    [showRefresh]="showRefresh"
    [showSystemDate]="showSystemDate"
    [systemDate]="systemDate() || ''"
    [systemDateLabel]="'LAYOUT.SYSTEM_DATE' | translate"
    [searchPlaceholder]="'LAYOUT.SEARCH_PLACEHOLDER' | translate"
    (search)="onGlobalSearch($event)"
    [showProductsButton]="showProducts"
    (productsClick)="productsClick()"
  ></lib-header>
  @if (showSearchResults()) {
    <div class="global-search-overlay" role="listbox">
      @if (searchResults().length > 0) {
        <div class="gs-title">
          {{ searchResults().length }}
          {{ (searchResults().length === 1 ? 'LAYOUT.RESULT' : 'LAYOUT.RESULTS') | translate }}
        </div>
        <div class="gs-list">
          @for (r of searchResults(); track r.route) {
            <button class="gs-item" type="button" (click)="onSelectSearchResult(r)">
              <lucide-icon class="gs-item-icon" [name]="r.icon"></lucide-icon>
              <span class="gs-item-text">
                <span class="gs-item-title">{{ r.label }}</span>
                @if (r.group) {
                  <span class="gs-item-group">{{ r.group }}</span>
                }
              </span>
            </button>
          }
        </div>
      } @else {
        <div class="gs-empty">{{ 'LAYOUT.NO_OPTIONS_FOUND' | translate }}</div>
      }
    </div>
  }

  @if (searchToast()) {
    <div class="gs-toast">{{ searchToast() }}</div>
  }

  @if (languages().length > 0) {
    <div class="lang-selector">
      <button
        class="lang-btn"
        type="button"
        (click)="toggleLangMenu()"
        [title]="'LAYOUT.LANGUAGE' | translate"
      >
        <span class="lang-flag">{{ activeFlag() }}</span>
      </button>
      @if (langMenuOpen()) {
        <div
          class="lang-menu"
          role="menu"
          [style.top.px]="langMenuTop()"
          [style.right.px]="langMenuRight()"
        >
          @for (l of languages(); track l.code) {
            <button
              class="lang-item"
              type="button"
              [class.active]="l.code === activeLang()"
              (click)="selectLanguage(l.code)"
            >
              <span class="lang-flag">{{ l.flagEmoji }}</span>
              <span class="lang-name">{{ l.nativeName }}</span>
            </button>
          }
        </div>
      }
    </div>
  }

  <button
    #triggerButton
    [matMenuTriggerFor]="profileMenu"
    class="menu-trigger-hidden"
    aria-hidden="true"
    tabindex="-1"
    type="button"
  >
    Menu
  </button>

  <mat-menu #profileMenu="matMenu" [overlapTrigger]="false" yPosition="below" xPosition="before">
    <div class="perfil-menu-header" (click)="$event.stopPropagation()">
      @if (userFullName()) {
        <div class="perfil-menu-name">{{ userFullName() }}</div>
      }
      <div class="perfil-menu-login">{{ userName }}</div>
      @if (userRoles()) {
        <div class="perfil-menu-roles">{{ userRoles() }}</div>
      }
    </div>
    <div class="perfil-menu-sep"></div>
    @for (item of itemsProfileMenu; track item.id) {
      <button mat-menu-item (click)="onProfileAction(item)" type="button">
        {{ profileItemLabel(item) }}
      </button>
    }
  </mat-menu>
</div>
